//validacion de los codigos que no requieren todos los formularios y los que si
export const validacionFormsObligatorios = {
idsFormsTodos: [
  { codigo: "003", text: "FORMULARIO 003" },
  { codigo: "005", text: "FORMULARIO 005" },
  // Nota: "FORMULARIO INFORME TECNICO" (inf) pasa a ser opcional
  // { codigo: "inf", text: "FORMULARIO INFORME TECNICO" },
  { codigo: "006", text: "FORMULARIO 006" },
  { codigo: "017", text: "FORMULARIO 017" },
  { codigo: "018", text: "FORMULARIO 018" },
  { codigo: "018pre", text: "FORMULARIO 018 PREANESTESICO" },
  { codigo: "020", text: "FORMULARIO 020" },
  { codigo: "022", text: "FORMULARIO 022" },
  { codigo: "024", text: "FORMULARIO 024" },
  { codigo: "060", text: "FORMULARIO 060" },
  { codigo: "cld", text: "FORMULARIO CHECK LIST" },
  { codigo: "rc", text: "INFORME RIESGO CAIDAS" }
],
  obligatorios: [],
  noObligatorios: [
    "27096AA",
    "31500AA",
    "36620AA",
    "36625AA",
    "62270",
    "31231",
    "31233",
    "92588",
    "30200",
    "92587",
    "92553",
    "92567",
    "271021",
    "271109",
    "281010",
    "281043",
    "281087",
    "281121",
    "281132",
    "281143",
    "281154",
    "281197",
    "281306",
    "281352",
    "281351",
    "281186",
    "92025",
    "92082",
    "92083",
    "281229",
    "281230",
    "76516",
    "76519",
    "92015",
    "92065",
    "92100",
    "65205",
    "65210",
    "65220",
    "65222",
    "281109",
    "12011",
    "12013",
    "12014",
    "12015",
    "12016",
    "12017",
    "12018",
    "12020",
    "12021",
    "91030",
    "91065",
    "91010",
    "91034",
    "91035",
    "91037",
    "231054",
    "231163",
    "231174",
    "57461",
    "19103",
    "19102",
    "19101",
    "11976",
    "59871",
  ],
};
